// i18n area 'auth' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.cs-CZ.meta.json.
import type { enUS } from './auth'

export const csCZ: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Přihlaste se ke svému účtu',
    username: 'Uživatelské jméno',
    usernamePlaceholder: 'Zadejte uživatelské jméno',
    usernameHint: 'Použijte uživatel@doména pro ověření vůči adresářovému realmu',
    continue: 'Pokračovat',
    changeUser: 'To nejste vy?',
    password: 'Heslo',
    forgotPassword: 'Zapomněli jste heslo?',
    submit: 'Přihlásit se',
    otp: 'Jednorázový kód',
    otpSubtitle: 'Zadejte kód ze svého autentikátoru',
    otpHint: 'Šest číslic z ověřovací aplikace, nebo jeden z kódů pro obnovení',
    otpSubmit: 'Ověřit',
    invalidCredentials: 'Neplatné uživatelské jméno nebo heslo',
    tooManyAttempts: 'Příliš mnoho pokusů — chvíli počkejte a zkuste to znovu',
    realmUnavailable: 'Realm teď nemůže ověřit přihlašovací údaje — store klastru není dostupný. Přihlaste se jako místní uživatel (break-glass).',
    genericError: 'Přihlášení se nezdařilo — je backend TVirt dostupný?'
  },
  user: {
    logout: 'Odhlásit se',
    password: {
      menu: 'Změnit heslo',
      title: 'Změňte si heslo',
      current: 'Aktuální heslo',
      new: 'Nové heslo',
      confirm: 'Potvrďte nové heslo',
      mismatch: 'Hesla se neshodují',
      error: 'Heslo se nepodařilo změnit',
      forcedTitle: 'Pro pokračování si změňte heslo',
      forcedHint: 'Toto heslo nastavil správce a před vstupem je nutné ho nahradit.',
      forcedSubmit: 'Změnit a vstoupit'
    },
    mfa: {
      title: 'Dvoufaktorové ověřování',
      subtitle: 'Druhý faktor vyžadovaný při každém přihlášení',
      loadError: 'Nepodařilo se načíst stav druhého faktoru',
      enrolled: 'Aktivní',
      notEnrolled: 'Neaktivní',
      enrolledAt: 'Aktivováno dne',
      codesRemaining: 'Zbývající kódy pro obnovení',
      requiredHint:
        'Správce na tomto účtu vyžaduje druhý faktor: nastavte si ho hned — dokud to neuděláte, můžete se přihlásit, ale skoro nic víc.',
      enroll: 'Nastavit',
      enrollTitle: 'Nastavit dvoufaktorové ověřování',
      enrollHint: 'Naskenujte tento kód ověřovací aplikací, poté pro potvrzení zadejte kód, který aplikace zobrazí.',
      secretHint: 'Nemůžete ho naskenovat? Zadejte do aplikace tento tajný klíč:',
      code: 'Kód z aplikace',
      confirm: 'Potvrdit',
      startError: 'Nepodařilo se zahájit nastavení',
      confirmError: 'Nepodařilo se potvrdit nastavení',
      codesTitle: 'Vaše kódy pro obnovení',
      codesWarning:
        'Tyto kódy se zobrazují jen jednou. Uložte si je hned: každý z nich vás přihlásí, když autentikátor není dostupný, a každý platí jen jednou.',
      codesAck: 'Kódy pro obnovení mám uložené',
      codesDone: 'Hotovo',
      copy: 'Kopírovat',
      copied: 'Zkopírováno',
      download: 'Stáhnout',
      regenerate: 'Nové kódy pro obnovení',
      regenerateTitle: 'Znovu vygenerovat kódy pro obnovení',
      regenerateHint: 'Všechny dosud vydané kódy přestanou fungovat v okamžiku, kdy se vygeneruje nová sada.',
      regenerateConfirm: 'Znovu vygenerovat',
      regenerateError: 'Nepodařilo se znovu vygenerovat kódy pro obnovení',
      remove: 'Odebrat',
      removeTitle: 'Odebrat druhý faktor',
      removeConfirm: 'Odebrat',
      removeHint: 'Účet se vrátí jen k heslu. Druhý faktor si můžete kdykoli nastavit znovu.',
      removeRequiredHint:
        'Správce na tomto účtu vyžaduje druhý faktor, server proto odebrání odmítne — požádejte ho nejprve o zrušení povinnosti.',
      removeError: 'Nepodařilo se odebrat druhý faktor'
    },
    profile: {
      menu: 'Přejít na můj profil',
      sessions: 'Aktivní relace',
      sessionsHint: 'Vaše otevřené relace na tomto uzlu',
      sessionsEmpty: 'Žádné aktivní relace',
      sessionCreated: 'Přihlášeno',
      sessionExpires: 'Vyprší',
      revoke: 'Odvolat relaci',
      revokeError: 'Nepodařilo se odvolat relaci',
      loadError: 'Nepodařilo se načíst relace'
    }
  }
}
